export const COUNTRIES = [
  {
    value: 'AR',
    text: 'Argentina',
    lat: -38.416097,
    lon: -63.616672,
    telCode: 54,
    tz: 'America/Argentina/Buenos_Aires',
  },
  {
    value: 'BO',
    text: 'Bolivia',
    lat: -16.290154,
    lon: -63.588653,
    telCode: 591,
    tz: 'America/La_Paz',
  },
  {
    value: 'BR',
    text: 'Brasil',
    lat: -23.533773,
    lon: -46.62529,
    telCode: 55,
    tz: 'America/Sao_Paulo',
  },
  {
    value: 'UY',
    text: 'Uruguay',
    lat: -32.522779,
    lon: -55.765835,
    telCode: 598,
    tz: 'America/Montevideo',
  },
  {
    value: 'CL',
    text: 'Chile',
    lat: -35.675147,
    lon: -71.542969,
    telCode: 56,
    tz: 'America/Santiago',
  },
  {
    value: 'ES',
    text: 'España',
    lat: 40.463667,
    lon: -3.74922,
    telCode: 34,
    tz: 'Europe/Madrid',
  },
  {
    value: 'MX',
    text: 'México',
    lat: 19.432608,
    lon: -99.133209,
    telCode: 52,
    tz: 'America/Mexico_City',
  },
  {
    value: 'CO',
    text: 'Colombia',
    lat: 4.570868,
    lon: -74.297333,
    telCode: 57,
    tz: 'America/Bogota',
  },
  {
    value: 'CR',
    text: 'Costa Rica',
    lat: 9.934739,
    lon: -84.087502,
    telCode: 506,
    tz: 'America/Costa_Rica',
  },
  {
    value: 'PE',
    text: 'Peru',
    lat: -9.189967,
    lon: -75.015152,
    telCode: 51,
    tz: 'America/Lima',
  },
  {
    value: 'EC',
    text: 'Ecuador',
    lat: -1.831239,
    lon: -78.183406,
    telCode: 593,
    tz: 'America/Guayaquil',
  },
  {
    value: 'PA',
    text: 'Panama',
    lat: 8.537981,
    lon: -80.782127,
    telCode: 507,
    tz: 'America/Panama',
  },
  {
    value: 'US',
    text: 'Estados Unidos',
    lat: 37.09024,
    lon: -95.712891,
    telCode: 1,
    tz: 'America/New_York', // Note: The US has multiple time zones
  },
  {
    value: 'PY',
    text: 'Paraguay',
    lat: -25.30066,
    lon: -57.63591,
    telCode: 595,
    tz: 'America/Asuncion',
  },
  {
    value: 'VE',
    text: 'Venezuela',
    lat: 10.5,
    lon: -66.916664,
    telCode: 58,
    tz: 'America/Caracas',
  },
  {
    value: 'DO',
    text: 'República Dominicana',
    lat: 18.735693,
    lon: -70.162651,
    telCode: 1809,
    tz: 'America/Santo_Domingo',
  },
];

export const COUNTRIES_MAP = new Map(COUNTRIES.map((c) => [c.value, c]));
